import styles from "./PlanItem.module.scss";
import {IPackage} from "../../models/Package";
import React, {useState} from "react";
import useAppSelector from "../../hooks/useAppSelector";
import {useTranslation} from "react-i18next";
import PlanItemModal from "./PlanItemModal/PlanItemModal";
import useAppDispatch from "../../hooks/useAppDispatch";
import {openLoginPopup} from "../../store/notification/notificationSlice";

interface IPlanItemProps {
    item: IPackage
}

const PlanItem: React.FC<IPlanItemProps> = ({item}) => {

    const dispatch = useAppDispatch();
    const {t} = useTranslation();
    const {isAuthorized} = useAppSelector(state => state.profileSlice);
    const {gymSettings} = useAppSelector(state => state.gymSettingsSlice);
    const [showMoreActive, setShowMoreActive] = useState<boolean>(false);
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

    const findLessOptionPrice = () => {
        if (item.options.length === 0) return "0.00" ;
        return Math.min(...item.options.map(el => Number(el.price))).toFixed(2);
    }

    const checkShowShowMoreBtn = () => {
        return item.classes.length >= 4;
    }

    const clickOnPickOnPlan = () => {
        if (!isAuthorized) {
            dispatch(openLoginPopup({isOpen: true}));
        } else {
            setIsModalOpen(true);
        }
    }

    return (
        <>
            <div className={styles.item}>
                <div className={styles.box}>
                    <p className={styles.name}>{item.name}</p>
                    <p className={styles.price}>{gymSettings?.defaultCurrencyCode}{findLessOptionPrice()}</p>
                    {
                        item.description.length > 99 ? (
                            <p className={styles.description}>{item.description.slice(0, 96)}...</p>
                        ) : (
                            <p className={styles.description}>{item.description}</p>
                        )
                    }
                    <ul className={`${styles.list} ${checkShowShowMoreBtn() && styles.showMoreActive}`}>
                        {item.classes.slice(0, checkShowShowMoreBtn() && !showMoreActive ? 4 : item.classes.length).map(el => {
                            return (
                                <li key={el.id} className={styles.class}>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <g clipPath="url(#clip0_2416_9000)">
                                            <path
                                                d="M15.6282 2.61482C15.1332 2.11912 14.3293 2.11943 13.8336 2.61482L5.75659 10.6922L2.1667 7.1023C1.671 6.6066 0.867479 6.6066 0.371777 7.1023C-0.123926 7.598 -0.123926 8.40152 0.371777 8.89723L4.85894 13.3844C5.10663 13.6321 5.43143 13.7562 5.75625 13.7562C6.08107 13.7562 6.40617 13.6324 6.65387 13.3844L15.6282 4.40972C16.1239 3.91436 16.1239 3.11049 15.6282 2.61482Z"
                                                fill="#303030"/>
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_2416_9000">
                                                <rect width="16" height="16" fill="white"/>
                                            </clipPath>
                                        </defs>
                                    </svg>
                                    {el.trainningCourse.name}
                                </li>
                            )
                        })}
                    </ul>
                    {
                        checkShowShowMoreBtn() && <button className={styles.showMoreBtn} onClick={() => setShowMoreActive(!showMoreActive)}>{ showMoreActive ? t("ShowLess") : t("ShowMore")}</button>
                    }
                </div>
                <button className={styles.btn} onClick={clickOnPickOnPlan}>{t("PickAnOption")}</button>
            </div>
            {
                isModalOpen && (
                    <PlanItemModal
                        item={item}
                        setIsModalOpen={setIsModalOpen}
                    />
                )
            }
        </>
    )
}

export default PlanItem;